import React from "react";
import {
  Modal,
} from 'reactstrap';
import { CancelPinpayContainer } from "../Operation/TablesOperation/TableOperation/styles";
import { ReactComponent as DeleteImg } from '../../assets/img/delete2.svg';
import { Button as NewButton } from 'takeat-design-system-ui-kit';
import WaitingPayment from '~/components/waiting-payment';

export default function PinpadPaymentFlow({
  isLeavingPayment,
  handleSwitchPinpadCancelStatus,
  handleCancelPinpadPayment,
  currentPaymentFlow,
  savePaymentAsync,
  handleStartPinpadPayment,
  onResetPinpadOperation
}) {
  return <>
    <Modal
      isOpen={isLeavingPayment}
      backdrop="static"
    >
      <CancelPinpayContainer>
        <span>
          <DeleteImg
            width={52}
            height={52}
          />
          <div>
            Tem certeza que deseja cancelar o pagamento?
          </div>
        </span>
        <div>
          <NewButton 
            onClick={() => handleSwitchPinpadCancelStatus(false)}
            style={{
              backgroundColor: ' #c8131b',
              color: 'white',
              border: '2px solid #c8131b',
              borderRadius: '12px'
            }} 
          >
            Não cancelar
          </NewButton>  
          <NewButton 
            onClick={() => {
              handleCancelPinpadPayment()
            }}
            style={{
              backgroundColor: 'white',
              color: '#c8131b',
              border: '2px solid #c8131b',
              borderRadius: '12px'
            }} 
          >
            Sim, cancelar
          </NewButton>
        </div>
      </CancelPinpayContainer>
    </Modal>
    <WaitingPayment
      currentPaymentFlow={currentPaymentFlow}
      onSavePayment={savePaymentAsync}
      onStartPinpadPayment={handleStartPinpadPayment}
      onCancelPinpadPayment={handleCancelPinpadPayment}
      onResetPinpadOperation={onResetPinpadOperation}
      onSwitchPinpadCancelStatus={() => handleSwitchPinpadCancelStatus(true)}
    />
  </>
}